import { GetGeneralDataString } from "../StringGenerators";

export const GetGeneralDataRequest = async (loadingStatus: (loadingState:boolean) => void, dataSetter: (json:any)=>void, errorSetter:(error:Error)=>void) => {
    try{
        loadingStatus(true);
        const response = await fetch(GetGeneralDataString());
        const json = await response.json();
        dataSetter(json);
        loadingStatus(false);
    }catch(error){
        if(error instanceof Error){
            errorSetter(error);
        }
        console.error("Error in GetGeneralDataRequest");
    }
}